import styled from 'styled-components';
import { Button } from 'react-bootstrap';

const ButtonWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: -10px;

  & button {
    margin-left: auto;
    font-size: 15px;
  }
`;

interface ISeasonPlaybackButtonProps {
  showPlayButton: boolean;
  shouldEnableAutoPlay: (userFields: any) => boolean;
  userFields: any;
  playDocuments: () => void;
  neverListenToPodcast: () => any;
}

function SeasonPlaybackButton({
  showPlayButton,
  shouldEnableAutoPlay,
  userFields,
  playDocuments,
  neverListenToPodcast
}: ISeasonPlaybackButtonProps) {
  return (
    <ButtonWrapper>
      {showPlayButton && shouldEnableAutoPlay(userFields) && (
        <Button
          onClick={playDocuments}
          bsClass="login-btn button-oval button-cta2-24"
          style={{ width: 225 }}
        >
          {neverListenToPodcast() && neverListenToPodcast().length > 0
            ? 'Resume Season Playback'
            : 'Start Season Playback'}
        </Button>
      )}
    </ButtonWrapper>
  );
}

export default SeasonPlaybackButton;
